<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-row class="mx-2">
                    <v-col cols="4">
                    <v-select label="กลุ่มงานบริการ" :items="groups">
                    </v-select>
                </v-col>
                <v-col cols="4">
                    <v-select label="Staff Name" :items="users">
                    </v-select>
                </v-col>
                </v-row>
                
            </template>
           
        </v-data-table>
    </v-container>
  
</template>

<script>
export default {
    name: "Data2_3",
    data: () => ({
        groups: ["All", "กลุ่มงาน A"],
        users: ["All", "user1", "user2", "user3"],
        headers: [
            {text: 'วันที่', value: 'date'},
            {text: 'User', value: 'user'},
            {text: 'Activity', value: 'activity'}
            ],
        desserts: [
            {'date': '01/03/2021', 'activity': 'Login', 'user': 'admin'},
            {'date': '02/03/2021', 'activity': 'Act1', 'user': 'user1'},
            {'date': '03/03/2021', 'activity': 'Act1', 'user': 'user2'},
            {'date': '04/03/2021', 'activity': 'Act1', 'user': 'user3'},
            {'date': '05/03/2021', 'activity': 'Act1', 'user': 'user1'},
            {'date': '06/03/2021', 'activity': 'Act1', 'user': 'user2'},
            {'date': '07/03/2021', 'activity': 'Act1', 'user': 'user3'}
        ]
    })
}
</script>